import { helperServices } from "../../shared/helper";

// export const erpConstants = {
export const GET_SALES_REQUEST = "GET_SALES_REQUEST";
export const GET_SALES_SUCCESS = "GET_SALES_SUCCESS";
export const GET_SALES_FAILURE = "GET_SALES_FAILURE";

export const ADD_SALES_REQUEST = "ADD_SALES_REQUEST";
export const ADD_SALES_SUCCESS = "ADD_SALES_SUCCESS";
export const ADD_SALES_FAILURE = "ADD_SALES_FAILURE";

export const UPDATE_SALES_REQUEST = "UPDATE_SALES_REQUEST";
export const UPDATE_SALES_SUCCESS = "UPDATE_SALES_SUCCESS";
export const UPDATE_SALES_FAILURE = "UPDATE_SALES_FAILURE";

export const DELETE_SALES_REQUEST = "DELETE_SALES_REQUEST";
export const DELETE_SALES_SUCCESS = "DELETE_SALES_SUCCESS";
export const DELETE_SALES_FAILURE = "DELETE_SALES_FAILURE";
export const DELETE_SERVICE = "delete";
export const EDIT_SERVICE = "edit";

export const PATIENT_VISIT_INTERNAL_STATUS = {
  BOOKED: "booked",
  MOVED_TO_BILLING: "MOVED_TO_BILLING",
  OPEN: "open",
  CLOSED: "close",
  INVOICE_GEN: "InvoiceGen",
  BILL_CLEAR: "BillClear",
  NOT_IN_SITE: "notInSite",
  NOT_VISITED: "NotVisited",
  Force_Close: "forceclose",
};

export const PATIENT_VISIT_STATUS = {
  OPEN: "open",
  CLOSED: "close",
  PRE_REG: "preReg",
};

// export const PATIENT_VISIT_INTERNAL_STATUS_MOVED_TO_BILLING = 'MOVED_TO_BILLING';

export const ERP_OUTSTANDING_BILL_LISTING = "OUTSTANDING_INVOICE_LISTING";
export const ERP_VISIT_FIN_SUMMARY_TYPE_INV = "INVOICE_LISTING";
export const ERP_VISIT_FIN_SUMMARY_TYPE_SO = "UNBILLED_SO_LISTING";
export const ERP_VISIT_FIN_SUMMARY_TYPE_PAYMENTS = "ADVANCE_PAYMENTS";
export const ERP_VISIT_FIN_SUMMARY_TYPE_REFUND_PAYMENTS = "REFUND_PAYMENTS";
export const ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE = "PRODS_FOR_NEWINVOICE";
export const ERP_VISIT_FIN_SUMMARY_TYPE_EDIT_INVOICE = "EDIT_INVOICE";
export const ERP_INVOICE_QUOTATION_TYPE = {
  "NEW_INVOICE_QUOTATION": "NEW_INVOICE_QUOTATION",
  "VIEW_QUOTATION_INVOICE": "VIEW_INVOICE_QUOTATION",
  "LIST_OF_INVOICE_QUOTATION": "LIST_OF_INVOICE_QUOTATION",

}

export const ERP_VISIT_DETAIL = "VISIT_DETAIL";
export const ERP_PATIENT_DETAIL = "PATIENT_DETAIL";
export const ERP_SERVICE_LIST = "ERP_SERVICE_LIST";
export const ERP_INVOICE_LIST = "ERP_INVOICE_LIST";
export const ERP_PAYMENT_LIST = "ERP_PAYMENT_LIST";
export const ERP_PRODUCT_LIST = "ERP_PRODUCT_LIST";
export const ERP_PRODUCT_LIST_ERROR = "ERP_PRODUCT_LIST_ERROR";
export const ERP_ALL_BANKS_DETAILS = "ALL_BANKS_DETAILS";
export const ERP_ALL_BANKS_DETAILS_ERROR = "ALL_BANKS_DETAILS_ERROR";
export const ERP_OUTSTANDING_BILLS = "ERP_OUTSTANDING_BILLS";
export const ERP_OUTSTANDING_BILLS_ERROR = "ERP_OUTSTANDING_BILLS_ERROR";
export const ERP_HMS_MASTER_LOCATION_DETAILS =
  "ERP_HMS_MASTER_LOCATION_DETAILS";
export const ERP_LABEl_CLEAR_BILL_PAYMENT_ADJUSTMENTS =
  "Clear Bill Adjustments";

export const ERP_INVOICE_WORKING_DATA_TYPE_VIEW_INVOICE = "VIEW_INVOICE";
export const ERP_INVOICE_WORKING_DATA_TYPE_EDIT_INVOICE = "EDIT_INVOICE";
export const ERP_INVOICE_WORKING_DATA_TYPE_SO_GENERATE_INVOICE =
  "SO_GENERATE_INVOICE";
export const ERP_INVOICE_WORKING_DATA_TYPE_PROD_GENERATE_INVOICE =
  "PROD_GENERATE_INVOICE";

export const ERP_PAYMENT_TYPE_ADVANCE = "ADVANCE";
export const ERP_PAYMENT_PAGE_TYPE_CLOSE_PAYMENT = "CLOSEPAYMENT";
export const ERP_PAYMENT_PAGE_TYPE_BACK_PAYMENT = "BACKPAYMENT";

export const HMS_ERP_BILL_CLEAR_ADVANCE_TYPE = {
  ERP_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR:
    "ERP_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR",
  ERP_ADVANCE_AMOUNT_TYPE_ADVANCE_PAYMENT:
    "ERP_ADVANCE_AMOUNT_TYPE_ADVANCE_PAYMENT",
  ERP_All_PATIENT_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR:
    "ERP_All_PATIENT_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR",
};

export const ERP_PAYMENT_COMPONENT_ACTION = {
  ERP_PAYMENT_BACK_ICON_ACTION: "PREVIOUS_PAGE_OF_PAYMENT_PAGE",
  ERP_PAYMENT_CLOSE_ICON_ACTION: "CLOSE_PAYMENT_PAGE",
  ERP_PAYMENT_CANCEL_ICON_ACTION: "ERP_PAYMENT_CANCEL_ICON_ACTION",
};

export const ERP_LABEL_PAYMENT_BACK_ICON = "PREVIOUS_PAGE_OF_PAYMENT_PAGE";
export const ERP_LABEL_PAYMENT_CLOSE_ICON = "CLOSE_PAYMENT_PAGE";

export const ERP_LABEL_GENERATE_INVOICE = "Generate Invoice";
export const ERP_LABEL_MOVETOBILL = "Move To Billing";
export const ERP_LABEL_INTERNAL_STATUS_BOOKED = "booked";
export const ERP_LABEL_INTERNAL_STATUS_MOVED_TO_BILLING = "MOVED_TO_BILLING_CHECK";
export const ERP_LABEL_PREVIEW_INVOICE = "Preview Invoice";
export const ERP_LABEL_PRINT_INVOICE = "Print Invoice";
export const ERP_LABEL_PAY_NOW = "Pay Now";
export const ERP_LABEL_CANCEL = "Cancel";
export const ERP_LABEL_SUBMIT = "Submit";
export const ERP_LABEL_ADD_PAYMENT_REQUEST = "Add Payment Request";
export const ERP_LABEL_CLOSE = "Close";
export const ERP_LABEL_CONFIRM = "Confirm";
export const ERP_LABEL_PAYMENT = "Payment";
export const ERP_LABEL_VISIT_FIN_SUMMARY = "Visit Financial Summary";
export const ERP_LABEL_SERVICES = "Service List";
export const ERP_LABEL_NEW_INVOICE = "New Invoice";
export const ERP_LABEL_VIEW_INVOICE = "View Invoice";
export const ERP_LABEL_ADVANCE_REQUEST = "Advance/Refund Requests";
export const ERP_LABEL_REEVALUATE_INVOICE = "Re-Evaluate Invoice Discount";
export const ERP_LABEL_GENERATE_INVOICE_QUOTATION = "Generate Quotation";
export const ERP_LABEL_INVOICE_QUOTATION = "Quotation";
export const ERP_LABEL_PREVIEW_QUOTATION = "Preview Quotation";
export const ERP_LABEL_PRINT_QUOTATION = "Print Quotation";

export const HMS_NEW_INVOICE_REPORT_TYPE = {
  SO_INVOICE: "SoInvoice",
  INDIVIDUAL_INVOICE: "IndividualInvoice",
};
// export const ERP_LABEL_CONFIRM = "Generate Invoice";

export const ERP_INVOICE_BILLING_STAGE = "BILLING";
export const ERP_INVOICE_BILLING_STAGE_BACK_TO_BILLING_FROM_PAYMENT =
  "ERP_INVOICE_BILLING_STAGE_BACK_TO_BILLING_FROM_PAYMENT";

export const ERP_CASH_PAYMENT_METHOD = "CASH";
export const ERP_CREDIT_PAYMENT_METHOD = "CREDIT PAYMENT";
export const ERP_VOUCHER_PAYMENT_METHOD = "VOUCHER PAYMENT";
export const ERP_UPI_PAYMENT_METHOD = "UPI PAYMENT";

export const ERP_FIN_SUM_TOTAL_CREDITED_AMOUNT_BY_LOCATION =
  "ERP_FIN_SUM_TOTAL_CREDITED_AMOUNT_BY_LOCATION";
export const ERP_FIN_SUM_TOTAL_BILL_AMOUNT_BY_LOCATION =
  "ERP_FIN_SUM_TOTAL_BILL_AMOUNT_BY_LOCATION";
export const ERP_FIN_SUM_TOTAL_BALANCE_AMOUNT_BY_LOCATION =
  "ERP_FIN_SUM_TOTAL_BALANCE_AMOUNT_BY_LOCATION";

export const ERP_TABLE_NEW_INVOICE_ITEMS = "ERP_INVOICE_TABLE_NEW_INVOICE_ITEMS";
export const ERP_TABLE_SERVICES_ITEMS = "ERP_TABLE_SERVICES_ITEMS";
export const ERP_VISIT_FIN_TABLE_SO_ITEMS = "ERP_VISIT_FIN_TABLE_SO_ITEMS";
export const ERP_TABLE_VISIT_FINANCIAL_SUMMARY_ITEMS = "ERP_TABLE_NEW_INVOICE_ITEMS";
export const ERP_TABLE_NEW_QUOTATION_INVOICE_ITEMS = "ERP_TABLE_NEW_QUOTATION_INVOICE_ITEMS";

export const PATIENT_VISIT_TYPE = {
  OUTPATIENT: "OutPatient",
  INPATIENT: "InPatient",
};

export const ERP_BILLING_TYPE_SO = "SOBILLING";
export const ERP_BILLING_TYPE_NON_SO = "NONSOBILLING";
export const CANCEL_INVOICE = "Cancel Invoice";
// Define default row height
export const Min_Row_Height = 25;
// Calculate header height (1.5 times the row height)
export const HEADER_Height = Min_Row_Height * 1.5;

export const MONTH_SHORT_NAME = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const FINANCIALCARDSUMMARYTITLE = {
  TOTALBALANCE: "Total Balance",
  TOTALDISCOUNT: "Total Discount",
  TOTALWITHOUTDISCOUNT: "Total Without Discount",
  BILLABLETOTAL: "Billable Total",
  AMOUNTCREDITED: "Amount Credited",
};

export const ERP_HMS_ALL_MASTER_DETAILS = {
  displayName: "All",
  // 'id': 0,
  locationKey: "all",
  locationDetails: {
    erpLocationDetails: [
      {
        address: "",
        locationid: [],
        name: "All",
        prefix: "All",
      },
    ],
  },
  servicesAllowed: [],
    // servicesAllowed: ["SERVICES", "LAB", "X-RAY", "ULTRASOUND","HMS", "PANCHAKARMA","CONSULTATION"],

};

export const ERP_LOCATION_MAP_LOCATION_NAME = {
  0: "IP BILLING",
  1: "OP BILLING",
  2: "LABORATORY",
  3: "ULTRASOUND",
  4: "X-RAY",
  5: "SANTATHI",
  6: "APOLLO LABORATORY",
  7: "LIFE CELL",
  8: "SPARSHA",
  9: "PHARMACY",
  10: "MAIN STORE",
  11: "DIALYSIS",
  12: "GENERAL STORES",
  13: "GENERAL WARD",
  14: "ICU",
  15: "LT STORE",
  16: "NICU",
  17: "OT STORE",
  18: "PICU",
  19: "POW",
  20: "RENTAL BILLS",
};
// {
//   // 0: 'INPATIENT',
//   0: 'HMS',
//   1: 'PHARMACY',
//   2: 'HMS',
//   // 2: 'OUTPATIENT',
//   3: 'STORE',
//   4: 'OT'
// };

export const ERP_PAYMENT_MODE = {
  CASH: "CA",
  "": "",
  Credit_Card: "CC",
  UPI: "PT", //PAYTM
  VOUCHER: "VO",
};

export const ERP_CODE_TO_INVOICE_KEY = {
  CA: "cash",
  CH: "cheque",
  CC: "magcard",
  PT: "paytm",
  VO: "ticket",
  DD: "cheque",
  MO: "wallet",
  CB: "cash",
  IP: "paytm",
};

export const ERP_CURRENCY_OBJ = {
  id: 1,
  name: "INR",
  basecurrency: 1,
  currency_symbol: "Rs",
};

export const ERP_INVOICE_PAYMENT_MODE_WITH_ERP_PAYMENT_KEYS = {
  cash: "Cash",
  cheque: "Cheque",
  paperin: "Credit",
  ticket: "Voucher",
  magcard: "Credit Card",
  cashrefund: "Cash Refund",
  chequerefund: "Cheque Refund",
  paperout: "Credit Note",
  magcardrefund: "Credit Card Refund",
  wallet: "Wallet Points",
  paytm: "UPI",
};

export const ERP_INVOICE_PAYMENT_MODE = {
  Cash: "cash",
  Cheque: "cheque",
  Credit: "paperin",
  Voucher: "ticket",
  Credit_Card: "magcard",
  Cash_Refund: "cashrefund",
  Cheque_Refund: "chequerefund",
  Credit_Note: "paperout",
  "Credit_Card Refund": "magcardrefund",
  Wallet_Points: "wallet",
  UPI: "paytm",
};

export const ERP_ADV_PAYMENT_MODE = {
  CASH: "CA",
  DEMAND_DRAFT: "DD",
  CHEQUE: "CH",
  MONEY_ORDER: "MO",
  CREDIT_CARD: "CC",
  NEFT: "NT",
  RTGS: "RT",
  PAYTM: "PT",
  CASH_TO_BANK: "CB",
  IMPS: "IP",
};

export const PAYMENT_MODE_NORMALIZER = {
  // CASH
  CA: "CASH",
  cash: "CASH",

  // CREDIT CARD
  CC: "CREDIT CARD",
  magcard: "CREDIT CARD",

  // PAYTM / UPI
  PT: "UPI",
  paytm: "UPI",
};

export const ERP_PAYMENT_MODE_INV_PAYMENT_MODE = {
  CA: ERP_INVOICE_PAYMENT_MODE.Cash,
  CC: ERP_INVOICE_PAYMENT_MODE.magcard,
  PT: ERP_INVOICE_PAYMENT_MODE.paytm,
  VO: ERP_INVOICE_PAYMENT_MODE.ticket,
};

export const ERP_PATIENT_PAYMENT_OBJ = {
  customerId: "",
  paymentAmount: "",
  paymentDate: "",
  paymentMode: "",
  checkDate: "",
  checkNo: "",
  user: "", // helperServices.getLoggedUserID(),
  timestamp: "",
  description: "",
  notes: "advance/receipt",

  bankId: "",
  bankDepositId: "",
  bankDepositDescription: "",
  bankCharges: "",

  customerName: "",
  customerInfo: {
    customerId: "",
    customerName: "",
  },
  cashDetailId: "",
  chequeBookId: "",
  currency: "",
  journalId: "",
  exchangerate: "",
  currencyInfo: {
    currencyId: 1,
    // currencyName : '',
    // currencySymbol : '',
    baseCurrency: true,
  },
  hasOSPayment: "", //Boolean

  createdDate: "",
  bankName: "",

  fromDate: "",
  toDate: "",
  locationId: "",
  location: "",
  voucherId: "",
  customerBank: "",
  receivedAmount: "",
  customerTickets: [],
  customerPayment: [],
};

export const ERP_GENERATE_INVOICE_REQUEST = {
  isCredit: false, // Review after obtaining payload structure
  billNumber: null,
  billId: null,
  date: "",
  refund: false,
  m_sUser: "Support",
  m_sCustomerName: "",
  customerId: "",
  billType: "SL",
  location: "",
  salesperson: "Support",
  narration: "",
  custome1: "",
  custome2: "",
  custome3: "",
  discountRs: 0.0,
  discountPerc: 0.0,
  m_dDate: "",
  custome4: "Custom field 4",
  roundOffQaulifier: "ROUND_OFF_UP_OR_DOWN",
  narration1: " ",
  mrpInvoice: false,
  shippedAddress: "",
  currencyId: 1,
  totalInvoiceAmount: 0.0,
  narration: "",
  m_aLines: [
    {
      m_iTicketLine: 0,
      m_sProdRef: "1",
      m_sProdName: "DAY CARE",
      m_dMultiply: 1,
      m_dPrice: 500.0,
      salesOrderId: null,
      m_TaxInfo: {
        m_iID: 0,
        m_dRate: 0.0,
      },
      m_dPriceBuy: 1000.0,
      sellPriceIncTax: 500.0,
      uomId: null,
      m_discount_line: 0.5,
      varientId: null,
      batchNo: "0001",
      type1: null,
      type2: null,
      type3: null,
      type4: null,
      sizeId: null,
      mrp: 1000,
      m_doriginalPriceSell: 500,
      trackInventory: true,
    },
  ],
  invoicePayments: [
    {
      name: "cash",
      total: 236.0,
      chequeNo: null,
      chequeDate: null,
      givenAmount: 240.0,
    },
  ],
};

export const MASTER_LOCATION_DATA_LOCATION_KEY = {
  ALL: "all",
  IP_BILLING: "ipbilling",
  OP_BILLING: "opbilling",
  LABORATORY: "laboratory",
  ULTRASOUND: "ultrasound",
  "X-RAY": "x-ray",
  SANTATHI: "santathi",
  "APOLLO LABORATORY": "apollolaboratory",
  "LIFE CELL": "lifecell",
  SPARSHA: "sparsha",
  PHARMACY: "pharmacy",
  "MAIN STORE": "mainstore",
  DIALYSIS: "dialysis",
  "GENERAL STORES": "generalstores",
  "GENERAL WARD": "generalward",
  ICU: "icu",
  LT_STORE: "ltstore",
  NICU: "nicu",
  OT_STORE: "otstore",
  PICU: "picu",
  POW: "pow",
  RENTAL_BILLS: "rentalbills",
};

export const ERP_ERROR = "ERP_ERROR";

export const DEFAULT_BILLING_LOCATION_BY_VISIT_TYPE = "visitType";

export const INVOICE_REPORT_TYPE = {
  CONSOLIDATED: "consolidated",
  ESTIMATED: "estimate",
};

export const INVOICE_DETAILS_LABEL = {
  KPCASH: "CASH",
  KPCREDIT: "CREDIT",
};

export const INVOICE_REPORT_TYPE_LABEL = {
  CONSOLIDATED_INV_PREVIEW: "Consolidated Invoice Preview",
  CONSOLIDATED_INV_PRINT: "Consolidated Invoice Print",
  ESTIMATED_INV_PREVIEW: "Estimated Invoice Preview",
  ESTIMATED_INV_PRINT: "Estimated Invoice Print",
  DEPARTMENT_INV_PRINT: "Print All Invoice",
  SUMMARY_INV_PRINT: "Print Summary",
  DOWNLOAD_PRESCREPTION_EXCEL: "Download excel",
};

export const MESSAGE_TYPE = {
  SUCCESS: "success",
  ERROR: "error",
};
// };

export const HMS_ERPPAYMENT_PAYMENT_TYPE = {
  ADVANCE_PAYMENT_ONLY: "ADVANCEPAYMENTONLY",
  REFUND_PAYMENT_ONLY: "REFUNDPAYMENTONLY",
  PAYMENTREQUEST_ADVANCE_PAYMENT_ONLY: "PAYMENTREQUESTADVANCEPAYMENTONLY",
  PAYMENTREQUEST_REFUND_PAYMENT_ONLY: "PAYMENTREQUESTREFUNDPAYMENTONLY",
  ADVANCE_PAYMENT_WITH_OUTSTANDING_INVOICE_CLEAR:
    "ADVANCEPAYMENTWITHOUTSTANDINGINVOICECLEAR",
  INVOICE_PAYMENT_FOR_SELECTED_INVOICES: "INVOICEPAYMENTFORSELECTEDINVOICING",
  INVOICE_SETTLEMENT_FROM_ADVANCE_AMOUNT: "INVOICESETTLEMENTFROMADVANCEAMOUNT",
  NEW_INVOICE_PAY_NOW: "NEWINVOICEPAYNOW",
};

// Define default row height
export const AG_GRID_REACT_MIN_ROW_HEIGHT = 25;
// Calculate header height (1.5 times the row height)
export const AG_GRID_REACT_HEADER_ROW_HEIGHT = 25;

export const COMPONENT_WISE_AG_GRID_CONTAINER_HEIGHT = {
  ERPServicesList: "500px",
  MembershipServices: "500px",
  ERPInvoice: "500px",
  ERPVisitFinancialSummary: "500px",
  ERPOutstandingBills: "400px",
  HMSPaymentRequest: "350px",
  ERPQuotation: "370px",
};

export const COMPONENT_WISE_AG_GRID_PAGINATION = {
  ERPServicesList: true,
  ERPInvoice: true,
  ERPVisitFinancialSummary: true,
  ERPOutstandingBills: true,
  HMSPaymentRequest: true,
  ERPQuotation: true,
};

export const COMPONENT_WISE_AG_GRID_PAGINATION_SIZE = {
  ERPServicesList: true,
  ERPInvoice: 6,
  ERPVisitFinancialSummary: 15,
  ERPOutstandingBills: 10,
  HMSPaymentRequest: 10,
  ERPQuotation: 10,
};

export const HMS_PAYMENT_REUQEST_TYPE = {
  REFUND_REQUEST: "REFUND",
  ADVANCE_REQUEST: "ADVANCE",
};

export const HMS_PAYMENT_REUQEST_STATUS = {
  PAYMENT_REQUEST_REQUESTED: "PAYMENT_REQUEST_REQUESTED",
  PAYMENT_REQUEST_CONFIRMED: "PAYMENT_REQUEST_CONFIRMED",
  PAYMENT_REQUEST_COMPLETED: "PAYMENT_REQUEST_COMPLETED",
  RECEIPT_GENERATED: "RECEIPT_GENERATED",
};

export const HMS_REPORT_TEMPLATE_TYPE = {
  CONSOLIDATED_INVOICE: "consolidatedinvoice",
  SINGLE_INVOICE: "singleinvoice",
  REFUND_VOUCHER: "refundvoucher",
  ESTIMATE_INVOICE: "estimateinvoice",
  RECEIPT: "receipt",
  PRINT_ALL_INVOICE: "allinvoice",
  PRINT_INVOICE_SUMMARY: "invoicesummary",
};

export const PAGE_MODE = {
  ALL_INVOICELIST: "InvoiceListPage",
  SINGLE_INVOICE: "singleInvoice",
};

export const ERP_INVOICE_RECEIPT_REFUND_PREFIX = {
  RECEIPT_PREFIX: "Receipt_",
  REFUND_PREFIX: "Voucher_",
};

export const BILLING_LOCATION_NAMES = {
  IP_BILLING: "IP BILLING",
  OP_BILLING: "OP BILLING",
  LABORATORY: "LABORATORY",
  ULTRASOUND: "ULTRASOUND",
  "X-RAY": "X-RAY",
  SANTATHI: "SANTATHI",
  APOLLO_LABORATORY: "APOLLO LABORATORY",
  LIFE_CELL: "LIFE CELL",
  SPARSHA: "SPARSHA",
  PHARMACY: "PHARMACY",
  MAIN_STORE: "MAIN STORE",
  DIALYSIS: "DIALYSIS",
  GENERAL_STORES: "GENERAL STORES",
  GENERAL_WARD: "GENERAL WARD",
  ICU: "ICU",
  LT_STORE: "LT STORE",
  NICU: "NICU",
  OT_STORE: "OT STORE",
  PICU: "PICU",
  POW: "POW",
  RENTAL_BILLS: "RENTAL BILLS",
};

export const HMS_INVOICE_TYPE_NAME = {
  CONSOLIDATED_INVOICE: "Consolidated Invoice",
  INDIVIDUAL_INVOICE: "Individual Invoice",
};

export const VISIT_BILLING_STATUS = {
  BILLING_STATUS_ENABLED: "EN",
  BILLING_STATUS_DISABLED: "DIS",
};

export const BILLING_VISIT_FINANCIAL_SUMMARY_MORE_MENU_OPTIONS = {
  CONVERT_TO_CASH_LABEL: "Convert To Cash",
  CONVERT_TO_CASH_KEY: "Convert_To_Cash",
  CONVERT_TO_CREDIT_LABEL: "Convert To Credit",
  CONVERT_TO_CREDIT_KEY: "Convert_To_Credit",
};

export const VALIDATE_STRING_FORCLOSE = "Please complete billing before closing the patient.";
